import { render, staticRenderFns } from "./ViewCategoryEquipmentPage.vue?vue&type=template&id=0d4e7cb4"
import script from "./ViewCategoryEquipmentPage.vue?vue&type=script&lang=js"
export * from "./ViewCategoryEquipmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports